import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { DiskContext } from '../context';
import { useForm } from 'react-hook-form';
import { FileFolderIcon } from '../my-disk/file-icon';
import { isFile } from 'v4/components/utils';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
export const DiskRenameFileModal = forwardRef(({ ...props }, ref) => {
  const {
    renameDisc,
    renameFileFolder,
    renameFileFolderLoading,
    selectedFile,
  } = useContext(DiskContext);
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const handleInputChange = (e) => {
    const value = e.target.value.replace(/\b\w/g, (c) => c.toUpperCase());
    setValue("name", value, { shouldValidate: true });
  };

  const onSubmit = ({ name }) => {
    renameFileFolder({ file: selectedFile, name });
  };
  
  const { t } = useTranslator();
  const direction = useDirection();
  return (
    <>
      <Modal {...renameDisc}>
        <ModalOverlay />
        <ModalContent>
          <form onSubmit={handleSubmit(onSubmit)}>
            <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
            <ModalHeader>
              <HStack alignItems={'flex-start'}>
                <Stack spacing={0} gap={0}>
                  <Heading size="md">
                    {t('myDisk.rename') || "Rename"} {isFile(selectedFile) ? (t('otherModules.file') || 'File') : (t('myDisk.folder') || 'Folder')}
                  </Heading>
                </Stack>
              </HStack>
            </ModalHeader>
            <ModalBody>
              <FormControl isInvalid={errors?.name}>
                <FormLabel>
                  {isFile(selectedFile) ? (t('otherModules.file') || 'File') : (t('myDisk.folder') || 'Folder')} {t('otherModules.name') || "name"}
                </FormLabel>
                <Input
                  borderRadius="full"
                  defaultValue={selectedFile?.name}
                  {...register('name', { required: true })}
                  onChange={handleInputChange}
                />
                <FormErrorMessage>{t('myDisk.pleaseEnterValidName') || "Please enter a valid name"}</FormErrorMessage>
              </FormControl>
            </ModalBody>
            <ModalFooter>
              <HStack>
                <Button borderRadius="30px" onClick={renameDisc?.onClose} variant="secondary">
                  {t('buttons.cancel') || "Cancel"}
                </Button>
                <Button
                  borderRadius="30px"
                  isLoading={renameFileFolderLoading}
                  type="submit"
                  variant="primary"
                >
                  {t('myDisk.rename') || "Rename"}
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </>
  );
});
